'use client';

import Link from "next/link";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useData, useLocalePath } from "@/i18n/LangContext";

export default function NotFound() {
  const { ui } = useData();
  const lp = useLocalePath();
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    const body = document.body;
    const page = body.getAttribute('data-page') || 'home';
    setCurrentPage(page);
  }, []);

  const getColorVars = (page: string) => {
    switch (page) {
      case 'work':
        return {
          solid: '#1E0B32',
          light: '#ff88ff'
        };
      case 'about':
        return {
          solid: '#0C2019',
          light: '#88ff88'
        };
      case 'contact':
        return {
          solid: '#5A1510',
          light: '#ff8855'
        };
      case 'imprint':
        return {
          solid: '#325E4D',
          light: '#a2fad8'
        };
      case 'privacy':
        return {
          solid: '#565C2B',
          light: '#C8D671'
        };
      default:
        return {
          solid: '#0C0B32',
          light: '#88ffff'
        };
    }
  };

  const colors = getColorVars(currentPage);

  return (
    <div className="h-[calc(100vh-160px)] flex items-center justify-center p-4">
      <div className="text-center max-w-2xl mx-auto">
        <motion.div
          initial={{ scale: 0.5, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="text-9xl font-bold mb-6"
          style={{
            backgroundImage: `linear-gradient(to right, ${colors.light}, ${colors.light}80)`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            color: 'transparent'
          }}
        >
          404
        </motion.div>
        
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          className="bg-[rgba(0,0,0,0.2)] backdrop-blur-sm p-8 rounded-xl border"
          style={{
            borderColor: `${colors.light}33`,
            boxShadow: `0 0 25px ${colors.light}1a`
          }}
        >
          <h1 className="text-2xl md:text-3xl font-semibold mb-4 text-white">
            {ui.notFound.title}
          </h1>
          
          <p className="text-white/70 mb-8 text-lg">
            {ui.notFound.text}
          </p>

          <Link href={lp('/')}>
            <motion.button
              className="px-8 py-4 rounded-lg font-medium"
              style={{
                backgroundColor: colors.solid,
                color: colors.light,
                borderColor: `${colors.light}4d`,
                borderWidth: '1px',
                borderStyle: 'solid'
              }}
              whileHover={{
                scale: 1.05,
                backgroundColor: colors.solid,
                borderColor: colors.light
              }}
              whileTap={{ scale: 0.97 }}
            >
              {ui.notFound.backHome}
            </motion.button>
          </Link>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
          className="mt-12 text-white/50 text-sm"
        >
          <p>
            {ui.notFound.funFact}
          </p>
        </motion.div>
      </div>
    </div>
  );
} 